{
  "schemaVersion": "1.0.0",
  "scenarioId": "adversarial",
  "payload": {
    "records": [
      {
        "id": 1,
        "full_name": "<script>alert('xss')</script>",
        "email": "hostile@example.com",
        "notes": "'; DROP TABLE users; --",
        "signup_date": "2024-01-01"
      },
      {
        "id": 2,
        "full_name": "Robert'); DROP TABLE students;--",
        "email": "bobby.tables@example.com",
        "notes": "<img src=x onerror=alert(1)>",
        "signup_date": "2024-01-02"
      },
      {
        "id": 3,
        "full_name": "javascript:alert(document.cookie)",
        "email": "payload@example.com",
        "notes": "${7*7} {{7*7}} #{7*7} texto de relleno repetido para probar truncado de celdas largas. texto de relleno repetido para probar truncado de celdas largas. texto de relleno repetido para probar truncado de celdas largas.",
        "signup_date": "2024-01-03"
      },
      {
        "id": 4,
        "full_name": "Ñañez Muñoz 日本語テスト",
        "email": "unicode@example.com",
        "notes": "Texto con emojis 🔥💥 y control-char",
        "signup_date": "2024-01-04"
      }
    ]
  },
  "options": { "deterministic": true }
}
